import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import { FlexWrap, Form } from 'components/UIComponents/FormStyles'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import CheckIconWhite from 'components/icons/CheckIconWhite'
import React, { useState } from 'react'
import { useParams } from 'react-router'
import SuccessMessage from 'utils/SuccessMessage'
import AddUserForm from './Partials'

const PreviewDrawer = ({
  form,
  handleCreate,
  errors,
  setErrors,
  confirmDrawer,
  setConfirmDrawer,
  appliedCandidatesListTrue,
  singleRoleData,
  setNoticePeriod,
  setCandidateYear,
  setRating,
  applyFilter,
  setApplyFilter,
  newPreviewDrawer,
  setNewPreviewDrawer,
  setshortListDrawer,
  rolesDegreeList,
  studentRating,
  setStudentRating,
  setDegreeDepartment,
  degreeDepartmentData,
  createShortList,
  getAppliedCandidateListTrue,
  degreeDepartment,
  candidateYear,
  noticePeriod,
  rating,
  candidateIds,
  setCandidateIds,
  setLocationStatus,
  locationStatus,
  setPrefferedLocationStatus,
  setCurrentLocationStatus,
  currentLocationStatus,
  prefferedlocationStatus,
  candidateRangeMin,
  candidateRangeMax,
  setCandidateRangeMin,
  setCandidateRangeMax,
  setPrefferedLocations,
  prefferedLocations,
  selectedRows,
  citySave,
  setExcandidateId,
  excandidateId,
}) => {
  const params = useParams()
  const [loading, setLoading] = useState(false)
  const onClose = value => {
    setNewPreviewDrawer(false)

    setNoticePeriod('')
    setCandidateYear('')
    setRating('')
    setCandidateIds([])
    setLocationStatus()
    setCandidateIds([])
    getAppliedCandidateListTrue({
      roleId: params?.jobId,
    })
    setPrefferedLocationStatus(false)
    setPrefferedLocations([])
    setCurrentLocationStatus(false)
    setCandidateRangeMax(0)
    setCandidateRangeMin(0)
    form.resetFields()
  }

  const GoBack = () => {
    setNewPreviewDrawer(false)
    setshortListDrawer(true)
    getAppliedCandidateListTrue({
      roleId: params?.jobId,
    })
  }

  const onSubmitFormData = async formData => {
    let payload = {
      ...formData,
      candidateIds: candidateIds,
      roleId: params?.jobId,
      driveMode: 'EXP_CANDIDATE_DRIVE',
      degreeDepartment: degreeDepartment,
    }
    if (currentLocationStatus) {
      payload.currentLocation = currentLocationStatus
    }
    if (prefferedlocationStatus) {
      payload.preferredLocation = prefferedLocations
    }
    if (candidateRangeMax > 0) {
      payload.workExperience = `${candidateRangeMin},${candidateRangeMax}`
    }
    let response = await createShortList(payload)
    if (response?.status === 200) {
      SuccessMessage('Candidate Shortlisted Successfully.')
      setNewPreviewDrawer(false)
      setConfirmDrawer(true)
      setPrefferedLocationStatus(false)
      setPrefferedLocations([])
      setCurrentLocationStatus(false)
      setCandidateIds([])
      setExcandidateId(response?.data?.data?.id)
      getAppliedCandidateListTrue({ roleId: params?.jobId })
    } else {
      ErrorMessage(response?.data?.message ?? response?.statusText)
      setLoading(false)
    }
  }
  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'addUserForm'}
        form={form}
        layout="vertical"
        onFinish={onSubmitFormData}
      >
        <AddUserForm
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          handleCreate={handleCreate}
          errors={errors}
          setErrors={setErrors}
          setNoticePeriod={setNoticePeriod}
          setCandidateYear={setCandidateYear}
          setRating={setRating}
          appliedCandidatesListTrue={appliedCandidatesListTrue}
          studentRating={studentRating}
          degreeDepartment={degreeDepartment}
          setStudentRating={setStudentRating}
          setDegreeDepartment={setDegreeDepartment}
          degreeDepartmentData={degreeDepartmentData}
          rolesDegreeList={rolesDegreeList}
          singleRoleData={singleRoleData}
          candidateRangeMin={candidateRangeMin}
          candidateRangeMax={candidateRangeMax}
          locationStatus={locationStatus}
          selectedRows={selectedRows}
          prefferedlocationStatus={prefferedlocationStatus}
          prefferedLocations={prefferedLocations}
          currentLocationStatus={currentLocationStatus}
          citySave={citySave}
          excandidateId={excandidateId}
        />
      </Form>
    )
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary text="Back to Edit" height="38px" onClick={GoBack} />
        <Button.Primary
          text={'Confirm'}
          htmlType="submit"
          form={'addUserForm'}
          icon={<CheckIconWhite />}
          height="38px"
          loading={loading}
        />
      </FlexWrap>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Preview'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={newPreviewDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default PreviewDrawer
